import { PopulatedAssessment, TemplateKey } from '@hb/shared'
import { useMemo } from 'react'
import { getDropdownItems } from './utils'

export const useTemplateDropdownItems = (
  assessment: PopulatedAssessment | null | undefined,
  type: TemplateKey,
) =>
  useMemo(() => {
    const items = getDropdownItems(assessment ?? null, type)
    const num = Object.keys(items).map(key => {
      const item = items[key]
      return Object.keys(item.children).length
    })
    const numAll = num.reduce((acc, curr) => acc + curr, 0)
    return { dropdownItems: items, numChildren: num, numAllChildren: numAll }
  }, [assessment, type])
